"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ArrowLeft = function () { return (react_1.default.createElement("svg", { width: "6", height: "12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { d: "M5.4.6L.6 6l4.8 5.4", stroke: "#1F1F1F", strokeLinecap: "round", strokeLinejoin: "round" }))); };
exports.default = ArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map